import { QuestionCore } from '../../types'

export const SPELLINGREGEL_QUESTIONS: QuestionCore[] = [
  {
    id: 'SPL-L1-001',
    module: 'SpellingRegel',
    difficulty: 1,
    question: 'Wat is het meervoud van "pan"?',
    options: ['pannen', 'panen', 'pansen', 'pannon'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-L1-002',
    module: 'SpellingRegel',
    difficulty: 1,
    question: 'Welk woord is goed gespeld?',
    options: ['gevaarlijk', 'gevaarluk', 'gevaarlek', 'gevaarelijk'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-L2-001',
    module: 'SpellingRegel',
    difficulty: 2,
    question: 'In welk woord klinkt de C als een K?',
    options: ['cactus', 'cent', 'cel', 'cijfer'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-L2-002',
    module: 'SpellingRegel',
    difficulty: 2,
    question: 'Welk woord moet met een hoofdletter?',
    options: ['Amsterdam', 'fiets', 'dinsdag', 'zomer'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-L3-001',
    module: 'SpellingRegel',
    difficulty: 3,
    question:
      'Wat is de persoonsvorm in deze zin: "De oude man loopt langzaam naar de overkant."',
    options: ['loopt', 'man', 'de oude man', 'langzaam'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-L3-002',
    module: 'SpellingRegel',
    difficulty: 3,
    question: 'Kies het juiste woord: De hond heeft zijn poot .....',
    options: ['bezeerd', 'bezeerts', 'bezeerdte', 'bezeerdt'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-L3-003',
    module: 'SpellingRegel',
    difficulty: 3,
    question: 'Welk woord is correct gespeld (trema)?',
    options: ['ideeën', 'ideeen', 'idëeen', 'ideeien'],
    correctAnswer: 0,
  },

  // NIEUW: Weetwoorden met é (café-woord)
  {
    id: 'SPL-WEET-L1-001',
    module: 'SpellingRegel',
    difficulty: 1,
    question: 'Welk woord is goed gespeld?',
    options: ['café', 'cafe', 'cafee', 'cafè'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-WEET-L1-002',
    module: 'SpellingRegel',
    difficulty: 1,
    question: 'Welk woord is goed gespeld?',
    options: ['idee', 'idé', 'idée', 'ide'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-WEET-L1-003',
    module: 'SpellingRegel',
    difficulty: 1,
    question: 'Vul in: Ik drink een kop koffi... in het café.',
    options: ['koffie', 'koffi', 'koffé', 'koffy'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-WEET-L2-001',
    module: 'SpellingRegel',
    difficulty: 2,
    question: 'Welk woord heeft een é (met accent)?',
    options: ['café', 'idee', 'thee', 'koffie'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-WEET-L2-002',
    module: 'SpellingRegel',
    difficulty: 2,
    question: 'Vul in: Mijn oom heeft een gezellig caf... in de stad.',
    options: ['café', 'cafe', 'cafee', 'cafè'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-WEET-L2-003',
    module: 'SpellingRegel',
    difficulty: 2,
    question: 'Welke woorden zijn allebei goed gespeld?',
    options: ['café en idee', 'cafe en idée', 'cafè en idee', 'café en idé'],
    correctAnswer: 0,
  },

  // NIEUW: Weetwoorden met eau (cadeau-woord)
  {
    id: 'SPL-WEET-L1-004',
    module: 'SpellingRegel',
    difficulty: 1,
    question: 'Welk woord is goed gespeld?',
    options: ['cadeau', 'cado', 'kadeau', 'kado'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-WEET-L1-005',
    module: 'SpellingRegel',
    difficulty: 1,
    question: 'Welk woord is goed gespeld?',
    options: ['bureau', 'buro', 'bureu', 'buroo'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-WEET-L2-004',
    module: 'SpellingRegel',
    difficulty: 2,
    question: 'Vul in: Ik heb een mooi ... gekregen voor mijn verjaardag.',
    options: ['cadeau', 'cado', 'kadeau', 'kado'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-WEET-L2-005',
    module: 'SpellingRegel',
    difficulty: 2,
    question: 'Welk woord eindigt op -eau?',
    options: ['bureau', 'auto', 'menu', 'euro'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-WEET-L3-001',
    module: 'SpellingRegel',
    difficulty: 3,
    question: 'Welke woorden zijn allebei goed gespeld?',
    options: [
      'cadeau en bureau',
      'cado en buro',
      'kadeau en bureau',
      'cadeau en buro',
    ],
    correctAnswer: 0,
  },
  {
    id: 'SPL-WEET-L3-002',
    module: 'SpellingRegel',
    difficulty: 3,
    question: 'Vul in: Op mijn bur... ligt een cad... van mijn vriend.',
    options: ['bureau, cadeau', 'buro, cado', 'bureau, cado', 'buro, cadeau'],
    correctAnswer: 0,
  },
  {
    id: 'SPL-WEET-L3-003',
    module: 'SpellingRegel',
    difficulty: 3,
    question: 'Welk woord hoort NIET bij de andere drie (let op de spelling)?',
    options: ['idee', 'café', 'cadeau', 'bureau'],
    correctAnswer: 0,
  },
]
